<script>
  import { cart } from "$lib/cart-store.svelte.js";
</script>

<footer class="flex flex-col gap-1">
  <div class="flex flex-col gap-1">
    {#if cart.showTax}
      <div
        class="flex justify-between items-center font-normal text-sm text-muted-foreground"
      >
        <span>Subtotal</span>
        <span>
          {Intl.NumberFormat("en-US", {
            style: "currency",
            currency: cart.currency,
          }).format(cart.subtotal) || "0.00"}
        </span>
      </div>
      <div
        class="flex justify-between items-center font-normal text-sm text-muted-foreground"
      >
        <span>Tax</span>
        <span>
          {Intl.NumberFormat("en-US", {
            style: "currency",
            currency: cart.currency,
          }).format(cart.tax) || "0.00"}
        </span>
      </div>
    {/if}
    <div class="flex justify-between items-center font-semibold">
      <span>Total</span>
      <span>
        {Intl.NumberFormat("en-US", {
          style: "currency",
          currency: cart.currency,
        }).format(cart.total) || "0.00"}
      </span>
    </div>
  </div>
  <button onclick={cart.actions.completeCheckout} class="btn w-full">
    Checkout
  </button>
</footer>
